import React from "react";
import "./sectionHeaderStyle.scss";
import Wizard from "../wizardSteps/WizardSteps";

const SectionHeader = ({ title, stepNo, totalStep, failedStep }) => {
    return (
      <div className="container section-header">
        <div className="row align-items-center"> 
          <div className="col-md-6">
            <h2 className="section-text">{title}</h2>
          </div> 
          {stepNo && <div className="col-md-6 ">
            <Wizard stepNo={stepNo} totalStep={totalStep} failedStep={failedStep} />
          </div>}
        </div>
      </div>
    );
  };
  
  export default SectionHeader;
